import type { TimeDomain } from '@/shared/charts/renderers/echarts/time-series-chart/types/TimeDomain.types';
import { lowerBound } from '@/shared/charts/renderers/echarts/time-series-chart/utils/lowerBound';
import type { TimeSeriesPoint } from '@/shared/charts/time-series-chart/TimeSeriesChart.types';
import { findIndexAfter, findIndexAtOrAfter } from '@/shared/charts/time-series-chart/points/findPointIndex';

/** Extra points past each edge of the window, so the detailed part joins its context without a gap. */
const EDGE_PADDING_POINTS = 1;

/** `[from, to)` indexes into a points array. */
type IndexRange = {
  from: number;
  to: number;
};

/** The points inside the visible range, one more on each side. A point exactly on an edge is inside. */
export function getWindowIndexRange(points: TimeSeriesPoint[], [start, end]: TimeDomain): IndexRange {
  return {
    from: Math.max(0, findIndexAtOrAfter(points, start) - EDGE_PADDING_POINTS),
    to: Math.min(points.length, findIndexAfter(points, end) + EDGE_PADDING_POINTS),
  };
}

/** The window's detailed indexes, with the coarse context's indexes before and after it. */
export function spliceWindowIndexes(contextIndexes: number[], window: IndexRange, detailIndexes: number[]): number[] {
  return [
    ...contextIndexes.slice(0, lowerBound(contextIndexes, window.from)),
    ...detailIndexes,
    ...contextIndexes.slice(lowerBound(contextIndexes, window.to)),
  ];
}
